import { Link, Navigate, useParams } from 'react-router-dom'
import { ResourcePage } from '../ui/ResourcePage'
import { RESOURCES, RESOURCE_GROUPS } from './resources'
import { Panel } from '../ui/kit'
import { usePageCrumb } from './breadcrumbs'

/**
 * Renders the right editing surface for /console/setup/:resource. All the variation
 * lives in the resource declaration, so there is one screen rather than seventeen.
 */
export function Setup() {
  const { resource } = useParams()
  const def = resource ? RESOURCES[resource] : undefined

  // Hooks cannot sit behind a return, so the crumb is set unconditionally and is
  // simply empty on the index.
  usePageCrumb(def ? [{ label: def.title }] : [])

  if (!resource) return <SetupIndex />
  if (!def) return <Navigate to="/console/setup" replace />

  return (
    <ResourcePage
      key={def.key}
      def={def}
      back={{ to: '/console/setup', label: 'Settings & lists' }}
    />
  )
}

function SetupIndex() {
  return (
    <main className="page">
      <div className="page-head">
        <h1>Settings &amp; lists</h1>
        <p>
          The lists everything else works from — your crops and grades, your stores and scales,
          your areas and vehicles. Get these right once and the rest of the system can check
          itself, instead of people arguing about it later.
        </p>
      </div>

      <div className="stack">
        {RESOURCE_GROUPS.map(({ group, keys }) => (
          <Panel key={group} title={group}>
            <div className="setup-grid">
              {keys.map((key) => {
                const def = RESOURCES[key]
                if (!def) return null
                return (
                  <Link key={key} to={`/console/setup/${key}`} className="setup-card">
                    <b>{def.title}</b>
                    <span>{def.description}</span>
                  </Link>
                )
              })}
            </div>
          </Panel>
        ))}
      </div>
    </main>
  )
}
